import loadingImage from '../assets/img/loading-image.gif';
export const AppraisalLoading: React.FC = (): JSX.Element => {
  return <div>
    <div className='ash-bg text-center pb-5'>
      <div>
        <span className='title'>Your Domain Valuation & Appraisal Is Almost Ready!</span>
      </div>
      <div>
        <img src={loadingImage} alt="type" className="loading-image" />
        <div className='fs-25'>
          Computing more than 216 data points…
        </div>
      </div>
    </div>
    <div className='container text-center mb-4 mt-4' >
      <span className='title'>
        Some Facts About Saw.com
      </span>
      <div className='row justify-content-center mt-4'>
        <div className='col-lg-3 col-md-6 col-sm-12 mt-3'>
          <div className='card card-custom-border'>
            We specialize in selling and buying premium domains
          </div>
        </div>
        <div className='col-lg-3 col-md-6 col-sm-12 mt-3'>
          <div className='card card-custom-border'>
            Our brokers average 15+ years of sales experience </div>
        </div>
        <div className='col-lg-3 col-md-6 col-sm-12 mt-3'>
          <div className='card card-custom-border'>
            We’ve completed more than $500m in domain sales </div>
        </div>
        <div className='col-lg-3 col-md-6 col-sm-12 mt-3'>
          <div className='card card-custom-border'>
            We help you create a more powerful online presence </div>
        </div>
      </div>
    </div>
  </div>
}
